import { Pipe, PipeTransform } from '@angular/core';
import { WorkTimerecordtypeNameEnum } from '@work-frontend-monorepo/work-rest-api';
import { AvatarStatus } from '../components/avatar/avatar.component';

@Pipe({
  name: 'getAvatarStatusByTimerecordtype',
  standalone: true,
})
export class GetAvatarStatusByTimerecordtypePipe implements PipeTransform {
  transform(timerecordtypeName: WorkTimerecordtypeNameEnum | null | undefined): AvatarStatus {
    switch (timerecordtypeName) {
      case WorkTimerecordtypeNameEnum.Arbeit:
        return 'available';
      case WorkTimerecordtypeNameEnum.Frei:
        return 'none';
      case WorkTimerecordtypeNameEnum.Ferien:
      case WorkTimerecordtypeNameEnum.MilitarZivilschutz:
      case WorkTimerecordtypeNameEnum.BezahlteAbsenz:
      case WorkTimerecordtypeNameEnum.Kompensation:
      case WorkTimerecordtypeNameEnum.Krank:
      case WorkTimerecordtypeNameEnum.Unfall:
      case WorkTimerecordtypeNameEnum.Feiertag:
      case WorkTimerecordtypeNameEnum.SchuleWeiterbildung:
        return 'absent';
      default: {
        return 'none';
      }
    }
  }
}
